// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"825386d9","549":"def4fdd7","781":"f6579e04","984":"3a3d3eb8"}[chunkId] + ".chunk.js";
};